import StatusIndicator from './StatusIndicator';

export { Statuses } from './StatusIndicator';

export default StatusIndicator;
